import classes from './Studio.module.css';
import starIcon from '../../public/icons/SternIcon.png';
import { Link } from 'react-router-dom';

export const Studio = ({ studio, fromUser }) => {

    return (
        <Link to={`/studio/${studio.id}`} className={classes.container}>
            <div className={classes.imageContainer}>
                <img src={studio?.processedImages[0]} alt="studio" />
                {!fromUser && (
                <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
                    <circle cx="6.5" cy="6.98047" r="6.5" fill="#FAFAFA"/>
                    <ellipse cx="6.5" cy="6.98047" rx="4.5" ry="4.5" fill="#FAFAFA"/>
                    <ellipse cx="6.5" cy="6.98047" rx="4.5" ry="4.5" fill="#00C514"/>
                </svg>
                )}
            </div>
            <div className={classes.detailsContainer}>
                <h3>{studio?.StudioName}</h3>
                <div className={classes.rattingContainer}>
                    <span className="regularSmall">{studio?.rating || "-"}</span>
                    <img src={starIcon} alt="star" />
                </div>
            </div>
            <h4 className={`${classes.location} regularXxs`}>{studio?.city}</h4>
        </Link>
  );
};

export default Studio;
